import axios from "@/axios-service";
import { ResponseContent, responseContent } from "../types";
import { AnalysisStatus } from "./types";

const MS_URL = "senana/api/farms/analysis";
const responseAsAnalysisStatus = responseContent(AnalysisStatus);

export const getAnalysesStatus = async (
  uuid: string
): Promise<ResponseContent<AnalysisStatus[]>> =>
  axios.get(`${MS_URL}/${uuid}/status`).then(responseAsAnalysisStatus);

export const getFarmAnalysisStatusByUuid = async (
  analysisUuid: string, 
  farmAnalysisUuid: string
): Promise<ResponseContent<AnalysisStatus>> =>
  axios.get(`${MS_URL}/${analysisUuid}/farmAnalysis/${farmAnalysisUuid}/status`)
  .then(responseAsAnalysisStatus);
  
